/* eslint-disable  @typescript-eslint/no-explicit-any */
import { ILanguageResponse } from '~/src/repositories/Other/models/Other'

export function convertLanguage(data: any): ILanguageResponse[] {
  return data?.map((item: any) => ({
    id: item.id,
    value: item.name.slice(0, 2).toLocaleLowerCase(),
    label: item.name,
  }))
}
